// Imports
import axios from 'axios'

// App Imports
import { API_URL } from '../../../../setup/config/env'

// Create or update media gallery
export function createOrUpdate(mediaGallery) {
  return dispatch => {
    return axios.post(API_URL, {
      operation: 'mediaGalleryCreateOrUpdate',
      params: mediaGallery
    })
  }
}

// Publish toggle for media gallery
export function publishToggle({ mediaGalleryId, isPublished }) {
  return dispatch => {
    return axios.post(API_URL, {
      operation: 'mediaGalleryPublishToggle',
      params: { mediaGalleryId, isPublished }
    })
  }
}

// Publish toggle for widget collection
export function widgetCollectionToggle({ mediaGalleryId, isPublished }) {
  return dispatch => {
    return axios.post(API_URL, {
      operation: 'widgetCollectionPublishToggle',
      params: { mediaGalleryId, isPublished }
    })
  }
}

// Toggle active/inactive for media gallery item
export function toggleItemActive({ mediaGalleryId, itemId, isActive }) {
  return dispatch => {
    return axios.post(API_URL, {
      operation: 'mediaGalleryItemToggleActive',
      params: { mediaGalleryId, itemId, isActive }
    })
  }
}

// Delete media gallery
export function remove({ mediaGalleryId }) {
  return dispatch => {
    return axios.post(API_URL, {
      operation: 'mediaGalleryDelete',
      params: { mediaGalleryId }
    })
  }
}

// Create or update category
export function createOrUpdateCategory(category) {
  return dispatch => {
    return axios.post(API_URL, {
      operation: 'mediaGalleryCategoryCreateOrUpdate',
      params: category,
    });
  };
}
// Delete a media gallery category (admin)
export function deleteCategory({ _id }) {
  return dispatch => {
    return axios.post(API_URL, {
      operation: 'mediaGalleryCategoryDelete',
      params: { _id }
    });
  };
}